import { CaretDownOutlined } from "@ant-design/icons";
import { Row, Select } from "antd";

import React from "react";
import {
  PRODUCT_PROPS_COVER,
  PRODUCT_PROPS_SOFA_ROSSY_LUXE_COVER,
} from "../../common/constant";
import {
  checkNewProductFeatureHaveCover,
  checkProductHaveCover,
  checkRossyLuxe,
  checkTypeValid,
} from "../../shared/helpers";

const DropdownCover = (props: any) => {
  const {
    features,
    productId,
    typeCover,
    handleOnChangeCover,
    checkDesk,
    minKdeProId,
  } = props;

  const options =
    checkRossyLuxe(productId) || checkNewProductFeatureHaveCover(features[0])
      ? PRODUCT_PROPS_SOFA_ROSSY_LUXE_COVER
      : PRODUCT_PROPS_COVER;

  return features &&
    features.length &&
    features[0].value &&
    checkProductHaveCover(
      features[0].value,
      checkRossyLuxe(productId),
      checkNewProductFeatureHaveCover(features[0])
    ) ? (
    <Row justify="center">
      <Select
        virtual={false}
        value={typeCover}
        onChange={handleOnChangeCover}
        className="product-item-select product-item-select--left"
        dropdownClassName="product-item-select__dropdown"
        suffixIcon={
          <CaretDownOutlined
            style={{
              color: "#0c3b5d",
            }}
            className={"flicker-color"}
          />
        }>
        {options && options.length
          ? options.map(
              (item: any, index: number) =>
                checkTypeValid(
                  features,
                  item.value,
                  checkDesk,
                  minKdeProId
                ) && (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    className="product-item-select__option">
                    <span className="product-item-select__label">
                      {item.label}
                    </span>
                  </Select.Option>
                )
            )
          : null}
      </Select>
    </Row>
  ) : null;
};

export default DropdownCover;
